import { isEmpty } from 'lodash';
import React from 'react';
import { Grid } from '@mui/material';
import { getFormattedDate } from '../../helpers/date-helpers';
import { TcsmNewsUpdateBlock } from '../../models/tcsm-block-models';
import { TcsmContentLinkView } from '../tcsm-content-link';


interface Props {
	blockData: TcsmNewsUpdateBlock;
}

export const TcsmNewsUpdateBlockView = (props: Props) => {

	const { blockData } = props;
	return (
		<div className="news-item">
			<Grid container spacing={1}>
				{!isEmpty(blockData?.thumbnailImage) && 
					<Grid item xs={12} sm={4}>
						<img src={blockData?.thumbnailImage} alt={blockData?.thumbnailImageAltText} />
					</Grid>}
			<Grid item xs={12} sm={8}>
				<p className="news-item-date">{getFormattedDate(blockData?.date)}</p>
				<h3 className="news-item-title">{blockData?.title}</h3>
				<p className="news-item-summary">{blockData?.summary}</p>
				<TcsmContentLinkView link={blockData?.itemLink} />
				</Grid>
			</Grid>
		</div>

	);

};


